const MY_MAPS_EMBED_URL = 'https://www.google.com/maps/d/embed?mid=117hvtH-DBVBO-nkAhiSWiQYHxFpZ9kw&ehbc=2E312F';

const BranchesMap = ({ height }) => (
    <iframe
        src={MY_MAPS_EMBED_URL}
        width="100%"
        height={height}
        style={{ border: 0, overflowX: 'hidden' }}
        title="Sucursales en México"
    />
);

export default BranchesMap;
